import React from 'react';
export function ProductSection() {
  const mainCover = 'https://cdn.magicpatterns.com/uploads/9igeQHSpmhprGitpqpDCso/01_cover.png';
  const scrollToOffer = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 bg-dark-light" data-id="element-149">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-150">
        <div className="w-full md:w-1/2 flex justify-center" data-id="element-151">
          <img src={mainCover} alt="Air Fryer Fácil" className="w-full max-w-md rounded-lg shadow-[0_20px_50px_rgba(0,0,0,0.5)] cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-152" />
        </div>

        <div className="w-full md:w-1/2 space-y-6" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight" data-id="element-154">
            <span className="text-primary" data-id="element-155">Air Fryer Fácil</span> es una
            colección con más de 100 recetas irresistibles
          </h2>

          <p className="text-xl text-gray-300" data-id="element-156">
            Para preparar comidas rápidas, deliciosas y saludables usando tu Air
            Fryer.
          </p>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-6" data-id="element-157">
            <p className="text-lg text-cream" data-id="element-158">
              Recetas pensadas para cocinar fácil todos los días, con
              ingredientes simples y resultados que siempre salen bien.
            </p>
          </div>
        </div>
      </div>
    </section>;
}